import * as tagUtil from "./LogTagData";

const dashboardPageLoad = () => {
    let data = {
        page_event: "view",
        service_application_event: "start, finish",
        service_application_step: "ebu: self service: my dashboard: home",
        service_application_name: "ebu: self service: my dashboard: home (query)",
        service_application_type: "query",
        page_name: "ebu: self service: my dashboard: home"
    };
    try {
        window.tagUtil.view(data);
    } catch (e) {
        tagUtil.logError(e);
    }
};

export {
    dashboardPageLoad
};
